import { ColorEnum } from '@/constants/color'
import IconButton from '@/features/ui/buttons/components/IconButton'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface QuantityButtonProps {
    quantity: number
    onPress: () => void
}

const QuantityButton: FC<QuantityButtonProps> = ({ quantity, onPress }) => {
    return (
        <IconButton
            type="filled"
            color="secondary"
            size={44}
            Icon={() => (
                <Typography.Heading
                    variant="h3"
                    style={{ color: ColorEnum.WHITE, userSelect: 'none' }}
                >
                    {quantity}
                </Typography.Heading>
            )}
            onPress={onPress}
        />
    )
}

export default QuantityButton
